import './App.css';
import HomePage from './component/homepage/HomePage';
import BillBoard from './component/billboard/BillBoard';
import UserInput from './component/UserInput/UserInput';
import Terms from './component/terms/Terms'
import ZipUpload from './component/zipUpload/ZipUpload';
import Gallery from './component/display/Gallery';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { useState } from 'react';

function App() {
  const [image, setImage] = useState(null);
  const [responseData, setResponseData] = useState(null)
  const getImageHandler = (data) =>{
    setImage(data)
  }
  const catchdata = (data) =>{
    console.log(data, "at app.js")
    setResponseData(data);
  }
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Terms/>} />
        <Route path='/home' element= {<HomePage  image={getImageHandler}/>}/>
        <Route path='/userinput' element ={<UserInput image={image} responsedata={catchdata}/>} />
        <Route path='/billboard' element ={<BillBoard />} />
        <Route path='/zip' element ={<ZipUpload />} />
        <Route path='/gallery' element ={<Gallery image={responseData}/>} />
      </Routes>
    </Router>
  );
}

export default App;
